import Main from "../Main";

const Home = () => {
    return (
        <div>
            <Main />
        </div>
    );
};

export default Home;
